import { SeverityNumber } from '@opentelemetry/api-logs';


export function mapSeverity(level: string): SeverityNumber {
    switch (level.toLowerCase()) {
        case 'info': return SeverityNumber.INFO;
        case 'warn': return SeverityNumber.WARN;
        case 'error': return SeverityNumber.ERROR;
        case 'fatal': return SeverityNumber.ERROR;
        default: return SeverityNumber.INFO;
    }
}

export function mapSeverityText(level: string): string {
    switch (level.toLowerCase()) {
        case 'info': return 'INFO';
        case 'warn': return 'WARN';
        case 'error': return 'ERROR';
        case 'fatal': return 'ERROR';
        default: return 'INFO';
    }
}